// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n3Py","toggleWrap":"styles_toggleWrap__2UJ50","content":"styles_content__2wANH","selectAreaCode":"styles_selectAreaCode__3CqYM"};